import { render, staticRenderFns } from "./postsalelistRD.vue?vue&type=template&id=7e4472e3&"
import script from "./postsalelistRD.vue?vue&type=script&lang=ts&"
export * from "./postsalelistRD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports